import { useQuery } from "@tanstack/react-query";
import { api } from "shared/api";

const fetchInternalNotesVisibility = async () => {
  const res = await api().gersGetInternalNotesVisibility();
  return res.data.canSeeInternalNotes;
};

export const useInternalNotesVisibility = () =>
  useQuery({
    queryKey: ["internal-notes-visibility"],
    queryFn: fetchInternalNotesVisibility,
  });
